<template>
  <div>
    <md-button class="md-icon-button md-fab-top-right md-dense md-primary" @click="saveSuperBom">
      <md-icon>save</md-icon>
    </md-button>
    <md-field>
      <label>Version</label>
      <md-input v-model="version"></md-input>
    </md-field>
    <vue-good-table
        ref="childrenBomTable"
        class="mx-4"
        :columns="columns"
        :rows="bomSameQuote"
        :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true,
            disableSelectInfo: true,
          }"
        :search-options="{
          enabled: false
        }"
        :line-numbers=" true
    ">
    <div slot="emptystate">There are no entries</div>
    <div slot="table-actions">
    </div>

    <div slot="selected-row-actions">
    </div>

    </vue-good-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';

export default {
  name: 'SuperBomDetail',

  components: {
    VueGoodTable,
  },

  computed: {
    ...mapGetters(['superBom', 'bomSameQuote']),
    version: {
      get() {
        if (this.superBom === null) {
          return null
        } else {
          return this.superBom.version
        }
      },
      set(value) {
        const superBom = this.superBom
        superBom.version = value
      }
    }
  },

  methods: {
    ...mapActions(['fetchChildBoms', 'fetchUpdateSuperBom', 'saveChildBoms', 'fetchSuperBomComponents']),
    saveSuperBom() {
      let superBom = JSON.parse(JSON.stringify(this.superBom))
      superBom.children = []
      for (let childBom of this.$refs['childrenBomTable'].selectedRows) {
        if (childBom.vgtSelected) {
          childBom.super_bom = this.$route.params.superBomId
          superBom.children.push({
            'id': childBom.id,
            'lot_size': childBom.lot_size,
            'super_bom': this.$route.params.superBomId,
            'version': childBom.version,
          })
        }
      }
      let childBoms = JSON.parse(JSON.stringify(this.bomSameQuote))
      for (let child of childBoms) {
        child.vgtSelected = false
        child.super_bom = null
      }
      for (let selectedRow of this.$refs['childrenBomTable'].selectedRows) {
        childBoms[selectedRow.originalIndex].vgtSelected = true
        childBoms[selectedRow.originalIndex].super_bom = superBom.id
      }
      this.fetchUpdateSuperBom(superBom)
      this.saveChildBoms(childBoms)
      this.fetchSuperBomComponents(this.$route.params.superBomId);
    },
  },

  async mounted() {
    this.fetchChildBoms(this.$route.params.superBomId);
  }
  ,

  data() {
    return {
      selectedRows: [],
      makeFetch: true,
      columns: [
        {
          label: 'Version',
          field: 'version_name',
          type: 'text',
          tdClass: 'resizeFont'
        },
        {
          label: 'Lot size',
          field: 'lot_size',
          type: 'number',
        },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.superBom {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
}

small {
  display: block;
}
</style>